import { render, staticRenderFns } from "./CharacterRoom.vue?vue&type=template&id=ab94ab46&scoped=true&"
import script from "./CharacterRoom.vue?vue&type=script&lang=ts&"
export * from "./CharacterRoom.vue?vue&type=script&lang=ts&"
import style0 from "./CharacterRoom.vue?vue&type=style&index=0&id=ab94ab46&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab94ab46",
  null
  
)

export default component.exports